export default "/reuni-eth.ef6cfa0eff554c7788e895fc52a82789.svg";